import * as Actions from "../Actions/EmpresaPessoaActions";

const initialState = {
    alterVinculo: null,
    gruposaprovacao: null,
    data: null,
    tipos: null,
    pagina: 1,
    template: null,
    formDialog: {
        type: "new",
        props: {
            id: null,
            open: false,
            error: null,
            warning: null,
            info: null
        },
        data: null
    },
    error: null

};

const EmpresaPessoaReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESAPESSOAS:
            {
                return {
                    ...state,
                    data: action.pagina === 1 ? action.payload : state.data.concat(action.payload),
                    pagina: action.pagina,
                    formDialog: {
                        ...state.formDialog,
                        props: {
                            ...state.formDialog.props,
                            id: null,
                        },
                    },
                };
            }
        case Actions.GET_EMPRESAPESSOA:
            {
                return {
                    ...state,
                    formDialog: {
                        type: "edit",
                        props: {
                            open: true,
                        },
                        data: action.payload
                    }
                };
            }
        case Actions.EMPRESAPESSOA_GRUPOS:
            {
                return {
                    ...state,
                    gruposaprovacao: action.payload,
                };
            }

        case Actions.OPEN_NEW_EMPRESAPESSOA_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: "new",
                        props: {
                            open: true
                        },
                        data: null
                    }
                };
            }
        case Actions.CLOSE_EMPRESAPESSOA_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: "new",
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.EMPRESAPESSOA_ERROR:
            {
                return {
                    ...state,
                    success: false,
                    formDialog: {
                        ...state.formDialog,
                        props: {
                            ...state.formDialog.props,
                            error: action.payload,
                        }
                    }
                };
            }
        case Actions.EMPRESAPESSOA_INFO:
            {
                return {
                    ...state,
                    success: true,
                    formDialog: {
                        ...state.formDialog,
                        type: "edit",
                        props: {
                            ...state.formDialog.props,
                            info: action.payload,
                            id: action.id,
                        }
                    }
                };
            }
        case Actions.EMPRESAPESSOA_WARNING:
            {
                return {
                    ...state,
                    success: true,
                    formDialog: {
                        ...state.formDialog,
                        props: {
                            ...state.formDialog.props,
                            warning: action.payload,
                        }
                    }
                };
            }
        case Actions.GET_TEMPLATE:
            {
                return {
                    ...state,
                    template: action.payload
                };
            }
        case Actions.EMPRESAPESSOA_VINCULAR:
            {
                return {
                    ...state,
                    alterVinculo: action.payload
                };
            }
        case Actions.GET_EMPRESAPESSOA_TIPOS:
            {
                return {
                    ...state,
                    tipos: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default EmpresaPessoaReducer;
